import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '@/core/data-fetching/queryKeys';
import { platformSettingsService } from '../api/platform-settings.service';

export function usePlatformSettings() {
  const client = useQueryClient();
  const query = useQuery({ queryKey: queryKeys.platformSettings, queryFn: () => platformSettingsService.get() });
  const save = useMutation({
    mutationFn: (enabled: boolean) => platformSettingsService.update({ selfServeSignupEnabled: enabled }),
    onSuccess: (data) => client.setQueryData(queryKeys.platformSettings, data),
  });
  return { query, save };
}
